import { createDefaultApiCache } from "@/utils/sessionDataCache";

export default () => ({
  apiCache: createDefaultApiCache(),
  stocks: {},
  userInfo: {},
  cart: {},
  conversionInfo: {},
  txs: {},
  stores: {},
  extensionHeight: "100px",
  settings: {},
  currencies: [],
  displayCurrency: {},
  marketInfo: {},
  allStocks: [],
  cryptoWalletStep: 1,
  isLogin: Boolean,
  stockExchanges: {},
  selectedExchange: {},
  bankAccount: {},
  tab: "",
  socketResponse: {},
  isLoginWithoutEmail: false,
  isIframeOpenEmitted: false,
  iframeDismissConfirmVisible: false,
  sessionNotifyStatus: { active: false },
  hostedPageId: "",
  resultPageData: {
    icon: "",
    title: "",
    description: "",
  },
  showFeedback: false,
  refrenceId: null,
  enrolledInRewards: {},
  // Opt-in is queued as a background job, so opt-status can still report false
  // right after enrolling. Set locally so the UI reflects the choice immediately.
  rewardsOptInPending: false,
  showRewardModal: false,
  rewardsBalance: null,
  fsStatus: 0,
  continuedTransaction: null,
});
